/**
 * Die Länderliste der Auswahlfelder — EINE Quelle für die ganze App
 * (Entscheid Peter, 31.08.2026).
 *
 * Vorher stand dieselbe Liste sechsmal wörtlich im Code: in beiden
 * Unternehmer-Masken, beiden Projekt-Masken und beiden Käufer-Masken. Wer ein
 * Land ergänzen wollte, musste sechs Dateien anfassen — und hätte beim
 * Übersehen einer Stelle ein Formular zurückgelassen, in dem das neue Land
 * fehlt.
 *
 * `code` ist der Wert, der gespeichert wird (zwei Zeichen, so verlangen es die
 * Prüfregeln im Backend: `location.country` => `max:2`). `name` ist die
 * Beschriftung im Auswahlfeld.
 */
export const countries = [
    { name: "CH", code: "CH" },
    { name: "DE", code: "DE" },
];

export default countries;
